module.exports = __webpack_public_path__ + "static/media/mobiel_bg_menu.1ccbec65.mp4";